import { render, staticRenderFns } from "./CommonUnsolved.vue?vue&type=template&id=6ca71bd4"
import script from "./CommonUnsolved.vue?vue&type=script&lang=js"
export * from "./CommonUnsolved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca71bd4')) {
      api.createRecord('6ca71bd4', component.options)
    } else {
      api.reload('6ca71bd4', component.options)
    }
    module.hot.accept("./CommonUnsolved.vue?vue&type=template&id=6ca71bd4", function () {
      api.rerender('6ca71bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/CommonUnsolved.vue"
export default component.exports